import React, { useState, useEffect } from 'react';
import getBackendUrl from './utils/backendConfig';

// ANCIEN COMPOSANT SUPPRIMÉ - Utilise ApiControlPanel centralisé
const ApiStatusButton_OLD_REMOVED = () => {
  const [apiStatus, setApiStatus] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  // Configuration du backend
  const getBackendUrl = () => {
    if (process.env.REACT_APP_BACKEND_URL) {
      return process.env.REACT_APP_BACKEND_URL;
    }
    const hostname = window.location.hostname;
    if (hostname === "localhost" || hostname === "127.0.0.1") return "http://localhost:8001";
    return '';
  };

  const BACKEND_URL = getBackendUrl();

  // Fonction pour récupérer le statut des API
  const fetchApiStatus = async () => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/health`);
      if (response.ok) {
        const healthData = await response.json();

        const adaptedStatus = {
          timestamp: new Date().toISOString(),
          apis: {
            gemini_1: { color: 'green', name: 'Gemini Key 1', status: 'active' },
            gemini_2: { color: 'green', name: 'Gemini Key 2', status: 'active' },
            gemini_3: { color: 'green', name: 'Gemini Key 3', status: 'active' },
            gemini_4: { color: 'green', name: 'Gemini Key 4', status: 'active' },
            bible_api: { color: healthData.bible_api_configured ? 'green' : 'red', name: 'Bible API', status: healthData.bible_api_configured ? 'active' : 'inactive' }
          },
          active_api: healthData.current_key || 'gemini_1'
        };

        setApiStatus(adaptedStatus);
      }
    } catch (error) {
      console.error('[API STATUS] Erreur:', error);
    }
  };

  const getLedColor = (api) => {
    return api.color === 'green' ? '#00ff00' : '#ff0000';
  };

  useEffect(() => {
    fetchApiStatus();
    const interval = setInterval(fetchApiStatus, 10000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      {/* Styles CSS pour les animations LED */}
      <style>
        {`
          @keyframes pulse-green {
            0%, 100% { 
              box-shadow: 0 0 8px #00ff00, 0 0 16px #00ff00; 
              opacity: 1; 
            }
            50% { 
              box-shadow: 0 0 12px #00ff00, 0 0 24px #00ff00; 
              opacity: 0.8; 
            }
          }
          @keyframes pulse-red {
            0%, 100% { 
              box-shadow: 0 0 8px #ff0000, 0 0 16px #ff0000; 
              opacity: 1; 
            }
            50% { 
              box-shadow: 0 0 12px #ff0000, 0 0 24px #ff0000; 
              opacity: 0.4; 
            }
          }
          .api-tooltip {
            position: absolute;
            top: -40px;
            left: 50%;
            transform: translateX(-50%);
            background: rgba(0,0,0,0.9);
            color: white;
            padding: 6px 12px;
            borderRadius: 8px;
            fontSize: 10px;
            whiteSpace: nowrap;
            zIndex: 1001;
            opacity: 0;
            transition: opacity 0.3s ease;
          }
          .api-tooltip.visible {
            opacity: 1;
          }
        `}
      </style>

      {/* Bouton API avec LEDs */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          background: 'linear-gradient(135deg, #3742fa, #2f3542)',
          border: 'none',
          borderRadius: '10px',
          color: 'white',
          padding: '8px 14px',
          fontSize: '12px',
          fontWeight: '600',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          boxShadow: '0 3px 10px rgba(55, 66, 250, 0.3)',
          fontFamily: 'Montserrat, sans-serif',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          position: 'relative',
          overflow: 'hidden'
        }}
        onMouseOver={(e) => {
          e.target.style.transform = 'translateY(-1px)';
          e.target.style.boxShadow = '0 4px 15px rgba(55, 66, 250, 0.4)';
          setShowTooltip(true);
        }}
        onMouseOut={(e) => {
          e.target.style.transform = 'translateY(0px)';
          e.target.style.boxShadow = '0 3px 10px rgba(55, 66, 250, 0.3)';
          setShowTooltip(false);
        }}
      >
        <span>⚡ API</span>

        {/* LEDs physiques individuelles */}
        {apiStatus && (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            background: 'rgba(255,255,255,0.15)',
            padding: '2px 6px',
            borderRadius: '6px'
          }}>
            {/* LED de statut global */}
            <div style={{
              width: '6px',
              height: '6px',
              borderRadius: '50%',
              backgroundColor: Object.values(apiStatus.apis).every(api => api.color === 'green') ? '#00ff00' : '#ff0000',
              animation: Object.values(apiStatus.apis).every(api => api.color === 'green') ? 'pulse-green 2s infinite' : 'pulse-red 1s infinite'
            }} />

            {/* LEDs individuelles pour chaque API */}
            <div style={{ display: 'flex', gap: '2px' }}>
              {Object.entries(apiStatus.apis).map(([key, api]) => (
                <div
                  key={key}
                  style={{
                    width: '4px',
                    height: '4px',
                    borderRadius: '50%',
                    backgroundColor: getLedColor(api),
                    animation: api.color === 'green' ? 'pulse-green 2s infinite' : 'pulse-red 1s infinite'
                  }}
                  title={`${api.name}: ${api.status}`}
                />
              ))}
            </div>
          </div>
        )}

        {/* Tooltip */}
        {showTooltip && apiStatus && (
          <div className={`api-tooltip ${showTooltip ? 'visible' : ''}`}>
            {Object.values(apiStatus.apis).every(api => api.color === 'green')
              ? '🟢 Toutes les API sont opérationnelles'
              : '🔴 Certaines API ont des problèmes'
            }
          </div>
        )}
      </button>

      {/* Panneau de contrôle détaillé */}
      {isOpen && (
        <div style={{
          position: 'absolute',
          top: '100%',
          right: '0',
          marginTop: '10px',
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          borderRadius: '12px',
          padding: '16px',
          minWidth: '280px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
          zIndex: 1000
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '12px',
            borderBottom: '1px solid rgba(0,0,0,0.1)',
            paddingBottom: '8px'
          }}>
            <h4 style={{
              margin: 0,
              color: '#333',
              fontSize: '14px',
              fontWeight: 'bold'
            }}>
              🔧 Statut des API
            </h4>
            <button
              onClick={() => setIsOpen(false)}
              style={{
                background: 'none',
                border: 'none',
                fontSize: '16px',
                cursor: 'pointer',
                color: '#666'
              }}
            >
              ×
            </button>
          </div>

          {/* Liste des API avec LEDs */}
          {apiStatus && (
            <div style={{ fontSize: '12px' }}>
              {Object.entries(apiStatus.apis).map(([key, api]) => (
                <div
                  key={key}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '6px 0',
                    borderBottom: '1px solid rgba(0,0,0,0.05)'
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{
                      width: '8px',
                      height: '8px',
                      borderRadius: '50%',
                      backgroundColor: getLedColor(api),
                      animation: api.color === 'green' ? 'pulse-green 2s infinite' : 'pulse-red 1s infinite'
                    }} />
                    <span style={{ color: '#333', fontWeight: '500' }}>
                      {api.name}
                    </span>
                  </div>
                  <span style={{
                    color: api.color === 'green' ? '#059669' : '#dc2626',
                    fontSize: '11px',
                    fontWeight: '600'
                  }}>
                    {api.color === 'green' ? '✅ OK' : '❌ ERR'}
                  </span>
                </div>
              ))}
            </div>
          )}

          {/* Rafraîchir */}
          <button
            onClick={fetchApiStatus}
            style={{
              marginTop: '12px',
              width: '100%',
              padding: '8px',
              background: 'linear-gradient(135deg, #3742fa, #2f3542)',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '12px',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            🔄 Rafraîchir
          </button>
        </div>
      )}
    </div>
  );
};

const BACKEND_URL = getBackendUrl();
const API_BASE = `${BACKEND_URL.replace(/\/+$/g, "")}/api`;

const VersetParVersetPage = ({ onGoBack, content, bookInfo }) => {
  const [currentBatch, setCurrentBatch] = useState(1); // Batch actuel (1, 2, 3...)
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [allVersetsBatches, setAllVersetsBatches] = useState({}); // Stocke tous les batches chargés
  const [totalVersetsExpected, setTotalVersetsExpected] = useState(null);
  const [enrichingVersets, setEnrichingVersets] = useState({}); // Track quels versets sont en cours d'enrichissement

  useEffect(() => {
    // Quand le contenu arrive, le stocker comme batch 1
    if (content) {
      setAllVersetsBatches(prev => ({
        ...prev,
        1: content
      }));
      setCurrentBatch(1);
    }
  }, [content]);

  // Fonction pour enrichir une explication théologique spécifique avec Gemini
  const enrichirExplicationGemini = async (versetNumber, currentExplication, versetText) => {
    const enrichKey = `${currentBatch}-${versetNumber}`;

    if (enrichingVersets[enrichKey]) return; // Déjà en cours

    setEnrichingVersets(prev => ({ ...prev, [enrichKey]: true }));

    try {
      console.log(`[GEMINI ENRICHISSEMENT] Enrichissement verset ${versetNumber} batch ${currentBatch}`);

      // Check if backend is available (skip localhost when backend isn't running)
      const isLocalhost = BACKEND_URL.includes('localhost') || BACKEND_URL.includes('127.0.0.1');

      if (isLocalhost) {
        console.log(`[ENRICHISSEMENT LOCAL] Génération d'enrichissement local pour verset ${versetNumber}`);

        // Générer un enrichissement théologique complet en mode local
        const enrichedContent = generateLocalEnrichment(versetNumber, versetText, currentExplication);

        // Mettre à jour le batch avec le contenu enrichi
        const currentBatchContent = allVersetsBatches[currentBatch];
        const versetPattern = new RegExp(`(\\*\\*✝️ PARTIE THÉOLOGIQUE :\\*\\*[\\s\\S]*?)(?=\\*\\*VERSET|---[\\s]*\\*\\*VERSET|$)`, 'gi');

        let matchIndex = 0;
        const updatedContent = currentBatchContent.replace(versetPattern, (match) => {
          matchIndex++;
          if (matchIndex === versetNumber || (currentBatch > 1 && matchIndex <= 3)) {
            // Trouver la position correcte
            return `**✝️ PARTIE THÉOLOGIQUE :**\n${enrichedContent}\n\n`;
          }
          return match;
        });

        // Alternative: remplacer directement le contenu du verset
        const directPattern = new RegExp(`(\\*\\*VERSET ${versetNumber}\\*\\*[\\s\\S]*?\\*\\*✝️ PARTIE THÉOLOGIQUE :\\*\\*)([\\s\\S]*?)(?=---[\\s]*\\*\\*VERSET|---[\\s]*\\*Mode|$)`, 'i');
        const finalContent = currentBatchContent.replace(directPattern, `$1\n${enrichedContent}\n\n`);

        setAllVersetsBatches(prev => ({
          ...prev,
          [currentBatch]: finalContent
        }));

        console.log(`[ENRICHISSEMENT LOCAL] Verset ${versetNumber} enrichi avec succès`);
        setEnrichingVersets(prev => ({ ...prev, [enrichKey]: false }));
        return;
      }

      const apiUrl = `${API_BASE}/generate-verse-by-verse`;

      const prompt = `ENRICHISSEMENT THÉOLOGIQUE APPROFONDI

Verset biblique : "${versetText}"
Explication actuelle : "${currentExplication}"

MISSION : Enrichir et approfondir cette explication théologique avec 200-300 mots supplémentaires.

AJOUTE :
- Contexte historique et culturel
- Liens avec d'autres passages bibliques
- Implications doctrinales profondes
- Applications pratiques modernes
- Perspectives herméneutiques

CONSERVE le texte original ET enrichis-le substantiellement.

GÉNÈRE DIRECTEMENT l'explication enrichie complète :`;

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          passage: `Enrichissement théologique`,
          version: 'LSG',
          tokens: 300,
          enriched: true,
          custom_prompt: prompt
        })
      });

      if (!response.ok) throw new Error(`Erreur API: ${response.status}`);

      const data = await response.json();

      if (data.content) {
        // Remplacer l'explication dans le batch actuel
        const currentBatchContent = allVersetsBatches[currentBatch];
        const versetPattern = new RegExp(`(VERSET ${versetNumber}[\\s\\S]*?EXPLICATION THÉOLOGIQUE[\\s\\S]*?:)([\\s\\S]*?)(?=VERSET|$)`, 'i');

        const enrichedExplication = data.content.replace(/.*EXPLICATION THÉOLOGIQUE.*?:/i, '').trim();
        const enrichedContentFinal = currentBatchContent.replace(versetPattern, `$1\n${enrichedExplication}\n`);

        // Mettre à jour le batch avec le contenu enrichi
        setAllVersetsBatches(prev => ({
          ...prev,
          [currentBatch]: enrichedContentFinal
        }));

        console.log(`[GEMINI ENRICHISSEMENT] Verset ${versetNumber} enrichi avec succès`);
      }

    } catch (error) {
      console.error(`[GEMINI ENRICHISSEMENT] Erreur verset ${versetNumber}:`, error);
    } finally {
      setEnrichingVersets(prev => ({ ...prev, [enrichKey]: false }));
    }
  };

  // Fonction pour générer un enrichissement local sans API
  const generateLocalEnrichment = (versetNumber, versetText, currentExplication) => {
    // Enrichissements théologiques profonds basés sur la saine doctrine
    const enrichissements = {
      1: `**ANALYSE EXÉGÉTIQUE APPROFONDIE**

${currentExplication}

**Étude du texte original :** Le terme hébreu "בָּרָא" (bara) utilisé pour "créer" est exclusivement réservé à l'action divine. Contrairement à "עָשָׂה" (asah - faire/fabriquer), bara indique une création ex nihilo, à partir de rien. Cette distinction linguistique établit la transcendance absolue du Créateur.

**Parallèles scripturaires :**
• Jean 1:1-3 - "Au commencement était la Parole... tout a été fait par elle"
• Colossiens 1:16 - "Car en lui ont été créées toutes les choses"
• Hébreux 11:3 - "C'est par la foi que nous reconnaissons que le monde a été formé par la parole de Dieu"
• Psaume 33:6,9 - "Les cieux ont été faits par la parole de l'Éternel... Il dit, et la chose arrive"

**Implications doctrinales :**
La doctrine de la création ex nihilo distingue le christianisme biblique du panthéisme (Dieu = création), du dualisme (deux principes éternels), et du déisme (Dieu absent). Elle établit la souveraineté absolue de Dieu sur Sa création et fonde le droit de Dieu à exiger l'obéissance de Ses créatures.

**Application spirituelle :**
Celui qui a créé les cieux et la terre peut aussi recréer un cœur nouveau en nous (2 Corinthiens 5:17). La puissance créatrice de Dieu est à l'œuvre dans notre sanctification.`,

      2: `**ANALYSE EXÉGÉTIQUE APPROFONDIE**

${currentExplication}

**Étude du texte original :** L'expression "תֹהוּ וָבֹהוּ" (tohu vabohu) décrit un état de non-organisation plutôt que de chaos destructeur. L'Esprit "מְרַחֶפֶת" (merachefet - planait/couvait) suggère une action protectrice et vivifiante, comme une aigle planant sur ses petits (Deutéronome 32:11).

**La Trinité dans la création :**
• Le Père - source et initiateur de la création (1 Corinthiens 8:6)
• Le Fils - agent et médiateur de la création (Jean 1:3, Colossiens 1:16)
• L'Esprit - vivificateur et sustentateur (Job 33:4, Psaume 104:30)

**Signification typologique :**
L'état initial "informe et vide" préfigure l'état du cœur humain avant la régénération. L'Esprit qui plane sur les eaux anticipe Son œuvre de régénération planant sur l'âme morte spirituellement (Ézéchiel 37:1-14).

**Parallèle avec la nouvelle création :**
Comme l'Esprit a transformé le chaos en cosmos ordonné, Il transforme le pécheur chaotique en nouvelle créature ordonnée selon l'image de Christ (Galates 5:22-23).

**Application pratique :**
Dans nos moments de confusion et de "chaos" personnel, l'Esprit de Dieu peut encore apporter ordre, lumière et vie. Il n'y a aucune situation trop désespérée pour Sa puissance régénératrice.`,

      3: `**ANALYSE EXÉGÉTIQUE APPROFONDIE**

${currentExplication}

**La puissance de la Parole divine :** Le "וַיֹּאמֶר אֱלֹהִים" (vayomer Elohim - "et Dieu dit") apparaît 10 fois dans Genèse 1, formant les "dix paroles" de la création, parallèles aux Dix Commandements. La Parole de Dieu est efficace et accomplit infailliblement Sa volonté.

**Théologie de la lumière :**
• La lumière comme première création visible manifeste le caractère de Dieu : "Dieu est lumière" (1 Jean 1:5)
• Christ s'identifie comme "la lumière du monde" (Jean 8:12, 9:5)
• L'Évangile produit la lumière spirituelle (2 Corinthiens 4:6)

**Dimension eschatologique :**
Cette lumière primordiale anticipe la lumière éternelle de la Nouvelle Jérusalem où "ils n'auront besoin ni de lampe ni de lumière du soleil, parce que le Seigneur Dieu les éclairera" (Apocalypse 22:5).

**Les pères de l'Église sur ce verset :**
• Augustin voyait dans cette lumière une image de l'illumination de l'âme par la grâce
• Jean Chrysostome soulignait l'obéissance instantanée de la création à la voix de Dieu
• Calvin enseignait que cette parole créatrice révèle la puissance infinie de Dieu

**Application pour le croyant :**
La même parole qui a dit "que la lumière soit" peut illuminer notre cœur (Psaume 119:130). Méditons la Parole pour recevoir cette lumière transformatrice. "Lève-toi, sois éclairée, car ta lumière arrive" (Ésaïe 60:1).`
    };

    // Retourner l'enrichissement correspondant ou un enrichissement générique
    return enrichissements[versetNumber] || `**ANALYSE EXÉGÉTIQUE APPROFONDIE**

${currentExplication}

**Approfondissement théologique :**
Ce passage révèle des vérités profondes sur le caractère de Dieu et Son plan rédempteur. La révélation progressive des Écritures nous permet de voir comment ce texte s'inscrit dans le grand récit de la rédemption accomplie en Christ.

**Références croisées bibliques :**
• Les Psaumes célèbrent la grandeur de Dieu manifestée dans la création
• Les Prophètes rappellent que le Créateur est aussi le Rédempteur
• Le Nouveau Testament révèle Christ comme le sens ultime de toute l'Écriture

**Application spirituelle :**
Que cette vérité transforme notre adoration et notre obéissance. Le Dieu qui a parlé jadis nous parle encore aujourd'hui par Sa Parole écrite. Écoutons avec révérence et obéissons avec joie.`;
  };

  // Fonction pour charger le batch suivant (versets 4-6, 7-9, etc.)
  const loadNextBatch = async () => {
    if (isLoadingMore) return;

    const nextBatch = currentBatch + 1;

    // Si on a déjà ce batch en cache, l'afficher directement
    if (allVersetsBatches[nextBatch]) {
      setCurrentBatch(nextBatch);
      return;
    }

    // Check if backend is available (skip localhost when backend isn't running)
    const isLocalhost = BACKEND_URL.includes('localhost') || BACKEND_URL.includes('127.0.0.1');
    if (isLocalhost) {
      console.log("[PAGINATION] Mode local - génération de contenu statique pour le batch suivant");

      // Générer du contenu statique pour le batch suivant
      const VERSES_PER_BATCH = 3;
      const startVerse = (nextBatch - 1) * VERSES_PER_BATCH + 1;

      const staticBatchContent = `**VERSET ${startVerse}**

**📖 AFFICHAGE DU VERSET :**
"Et Dieu vit que cela était bon." (verset ${startVerse})

**📜 CONTEXTE HISTORIQUE :**
La répétition de cette affirmation divine tout au long du récit de la création souligne la perfection originelle de l'œuvre divine. Chaque élément créé correspondait exactement au dessein éternel de Dieu.

**✝️ PARTIE THÉOLOGIQUE :**
Ce refrain "et Dieu vit que cela était bon" (וַיַּרְא אֱלֹהִים כִּי־טוֹב) révèle que la création était parfaite avant la chute. Cette bonté originelle contraste avec la corruption entrée par le péché (Romains 8:20-22). La doctrine de la création bonne établit que le mal n'est pas intrinsèque à la matière mais résulte de la rébellion contre Dieu.

---

**VERSET ${startVerse + 1}**

**📖 AFFICHAGE DU VERSET :**
"Dieu créa l'homme à son image, il le créa à l'image de Dieu." (verset ${startVerse + 1})

**📜 CONTEXTE HISTORIQUE :**
L'expression "צֶלֶם אֱלֹהִים" (tselem Elohim - image de Dieu) distingue l'humanité de toute la création. L'homme n'est pas un accident de l'évolution mais un être créé avec intention et dignité.

**✝️ PARTIE THÉOLOGIQUE :**
L'image de Dieu (imago Dei) comprend aspects rationnels, moraux et relationnels. Cette image a été ternie par le péché mais non détruite. Christ, "l'image du Dieu invisible" (Colossiens 1:15), restaure en nous cette image par la sanctification (2 Corinthiens 3:18).

---

**VERSET ${startVerse + 2}**

**📖 AFFICHAGE DU VERSET :**
"Dieu les bénit, et Dieu leur dit: Soyez féconds, multipliez." (verset ${startVerse + 2})

**📜 CONTEXTE HISTORIQUE :**
La bénédiction divine accompagne le commandement de procréation. Cette structure (bénédiction + mandat) établit le modèle de l'alliance entre Dieu et l'humanité.

**✝️ PARTIE THÉOLOGIQUE :**
Le mandat culturel (Genèse 1:28) confie à l'homme la responsabilité d'intendance sur la création. Cette vocation demeure valide après la chute, bien que rendue difficile par le péché. Christ, le second Adam, accomplit parfaitement ce mandat et nous y associe dans Son royaume.

---

*Mode hors-ligne : Continuez vers le batch suivant pour plus de versets.*`;

      setAllVersetsBatches(prev => ({
        ...prev,
        [nextBatch]: staticBatchContent
      }));
      setCurrentBatch(nextBatch);
      return;
    }

    setIsLoadingMore(true);

    try {
      // Calculer le range de versets à demander (3 versets par batch pour Vercel)
      const VERSES_PER_BATCH = 3;
      const startVerse = (nextBatch - 1) * VERSES_PER_BATCH + 1; // Batch 2 = versets 4-6, etc.
      const endVerse = startVerse + (VERSES_PER_BATCH - 1);

      // Extraire le livre et chapitre du bookInfo
      const bookChapter = bookInfo?.split(':')[0] || 'Genèse 1';
      const requestPassage = `${bookChapter}:${startVerse}-${endVerse}`;

      console.log(`[PAGINATION] Chargement batch ${nextBatch}: ${requestPassage}`);

      // Appeler l'API pour les versets suivants
      const apiUrl = `${API_BASE}/generate-verse-by-verse`;

      // Timeout de 60 secondes pour laisser le temps à la génération
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 60000); // 60 secondes

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          passage: requestPassage,
          version: 'LSG',
          tokens: 500,
          enriched: true
        }),
        signal: controller.signal
      }).finally(() => clearTimeout(timeoutId));

      if (!response.ok) {
        throw new Error(`Erreur API: ${response.status}`);
      }

      const data = await response.json();

      if (data.content) {
        // Stocker le nouveau batch
        setAllVersetsBatches(prev => ({
          ...prev,
          [nextBatch]: data.content
        }));
        setCurrentBatch(nextBatch);
        console.log(`[PAGINATION] Batch ${nextBatch} chargé avec succès`);
      } else {
        throw new Error('Pas de contenu reçu');
      }

    } catch (error) {
      console.error(`[PAGINATION] Erreur chargement batch ${nextBatch}:`, error);
      // Optionnel : afficher une erreur à l'utilisateur
    } finally {
      setIsLoadingMore(false);
    }
  };

  // Fonction pour naviguer vers un batch précédent
  const goToPreviousBatch = () => {
    if (currentBatch > 1) {
      setCurrentBatch(currentBatch - 1);
    }
  };

  // Obtenir le contenu du batch actuel
  const getCurrentBatchContent = () => {
    return allVersetsBatches[currentBatch] || '';
  };

  // Fonction pour gérer l'enrichissement d'un verset via React (pas via HTML onclick)
  const handleEnrichirVerset = async (versetNumber) => {
    console.log(`[GEMINI] Clic enrichissement verset ${versetNumber}`);

    // Extraire le texte du verset et l'explication actuelle
    const currentContent = getCurrentBatchContent();
    const versetRegex = new RegExp(`VERSET ${versetNumber}[\\s\\S]*?TEXTE BIBLIQUE[\\s\\S]*?:([\\s\\S]*?)EXPLICATION THÉOLOGIQUE[\\s\\S]*?:([\\s\\S]*?)(?=VERSET|$)`, 'i');
    const match = currentContent.match(versetRegex);

    if (match) {
      const versetText = match[1].trim();
      const currentExplication = match[2].trim();

      await enrichirExplicationGemini(versetNumber, currentExplication, versetText);
    }
  };

  // Fonction pour nettoyer les marqueurs Markdown
  const cleanMarkdownFormatting = (text) => {
    if (!text) return '';

    return text
      // Supprimer les ** pour le gras
      .replace(/\*\*/g, '')
      // Supprimer les * pour l'italique
      .replace(/(?<!\*)\*(?!\*)/g, '')
      // Nettoyer les espaces multiples
      .replace(/\s+/g, ' ')
      // Nettoyer les lignes vides multiples
      .replace(/\n\s*\n\s*\n/g, '\n\n')
      .trim();
  };

  // Nouvelle approche : Analyser le contenu et créer des composants React avec boutons intégrés
  const parseContentWithGeminiButtons = (content) => {
    if (!content) return [];

    const sections = [];
    const versetPattern = /(\*\*VERSET\s+(\d+)\*\*[\s\S]*?)(?=\*\*VERSET\s+\d+|$)/gi;

    let match;
    while ((match = versetPattern.exec(content)) !== null) {
      const versetNumber = parseInt(match[2]);
      const versetContent = match[1].trim();

      // Séparer le contenu en 4 parties : affichage du verset, chapitre, contexte historique, partie théologique
      const parts = versetContent.split(/(\*\*📖 AFFICHAGE DU VERSET\s*:\*\*|\*\*📚 CHAPITRE\s*:\*\*|\*\*📜 CONTEXTE HISTORIQUE\s*:\*\*|\*\*✝️ PARTIE THÉOLOGIQUE\s*:\*\*|\*\*TEXTE BIBLIQUE\s*:\*\*|\*\*EXPLICATION THÉOLOGIQUE\s*:\*\*)/i);

      let versetTitle = '';
      let affichageVerset = '';
      let chapitre = '';
      let contexteHistorique = '';
      let partieTheologique = '';

      for (let i = 0; i < parts.length; i++) {
        const part = parts[i].trim();

        if (part.includes('**VERSET')) {
          versetTitle = cleanMarkdownFormatting(part);
        } else if (part.match(/📖 AFFICHAGE DU VERSET|TEXTE BIBLIQUE/i)) {
          affichageVerset = cleanMarkdownFormatting(parts[i + 1]?.trim() || '');
          i++; // Skip next part as we've consumed it
        } else if (part.match(/📚 CHAPITRE/i)) {
          chapitre = cleanMarkdownFormatting(parts[i + 1]?.trim() || '');
          i++; // Skip next part as we've consumed it
        } else if (part.match(/📜 CONTEXTE HISTORIQUE/i)) {
          contexteHistorique = cleanMarkdownFormatting(parts[i + 1]?.trim() || '');
          i++; // Skip next part as we've consumed it
        } else if (part.match(/✝️ PARTIE THÉOLOGIQUE|EXPLICATION THÉOLOGIQUE/i)) {
          partieTheologique = cleanMarkdownFormatting(parts[i + 1]?.trim() || '');
          i++; // Skip next part as we've consumed it
        }
      }

      sections.push({
        number: versetNumber,
        title: versetTitle,
        affichageVerset: affichageVerset,
        chapitre: chapitre,
        contexteHistorique: contexteHistorique,
        partieTheologique: partieTheologique
      });
    }

    return sections;
  };

  // Fonction pour extraire les numéros de versets du contenu
  const extractVersetNumbers = (content) => {
    if (!content) return [];

    const versetPattern = /\*\*VERSET\s+(\d+)\*\*/gi;
    const matches = [];
    let match;

    while ((match = versetPattern.exec(content)) !== null) {
      matches.push(parseInt(match[1]));
    }

    return matches;
  };

  // Fonction helper pour convertir les références bibliques en URLs YouVersion
  const getBibleVerseUrl = (book, chapter, verse) => {
    // Mapping des livres français vers codes YouVersion
    const bookMapping = {
      'Genèse': 'GEN', 'Exode': 'EXO', 'Lévitique': 'LEV', 'Nombres': 'NUM', 'Deutéronome': 'DEU',
      'Josué': 'JOS', 'Juges': 'JDG', 'Ruth': 'RUT', '1 Samuel': '1SA', '2 Samuel': '2SA',
      '1 Rois': '1KI', '2 Rois': '2KI', '1 Chroniques': '1CH', '2 Chroniques': '2CH',
      'Esdras': 'EZR', 'Néhémie': 'NEH', 'Esther': 'EST', 'Job': 'JOB', 'Psaumes': 'PSA',
      'Proverbes': 'PRO', 'Ecclésiaste': 'ECC', 'Cantique': 'SNG', 'Ésaïe': 'ISA',
      'Jérémie': 'JER', 'Lamentations': 'LAM', 'Ézéchiel': 'EZK', 'Daniel': 'DAN',
      'Osée': 'HOS', 'Joël': 'JOL', 'Amos': 'AMO', 'Abdias': 'OBA', 'Jonas': 'JON',
      'Michée': 'MIC', 'Nahum': 'NAM', 'Habacuc': 'HAB', 'Sophonie': 'ZEP', 'Aggée': 'HAG',
      'Zacharie': 'ZEC', 'Malachie': 'MAL', 'Matthieu': 'MAT', 'Marc': 'MRK', 'Luc': 'LUK',
      'Jean': 'JHN', 'Actes': 'ACT', 'Romains': 'ROM', '1 Corinthiens': '1CO', '2 Corinthiens': '2CO',
      'Galates': 'GAL', 'Éphésiens': 'EPH', 'Philippiens': 'PHP', 'Colossiens': 'COL',
      '1 Thessaloniciens': '1TH', '2 Thessaloniciens': '2TH', '1 Timothée': '1TI', '2 Timothée': '2TI',
      'Tite': 'TIT', 'Philémon': 'PHM', 'Hébreux': 'HEB', 'Jacques': 'JAS', '1 Pierre': '1PE',
      '2 Pierre': '2PE', '1 Jean': '1JN', '2 Jean': '2JN', '3 Jean': '3JN', 'Jude': 'JUD',
      'Apocalypse': 'REV'
    };

    const bookCode = bookMapping[book] || 'GEN';
    // Version LSG (Louis Segond) en français = ID 93 sur YouVersion
    return `https://www.bible.com/bible/93/${bookCode}.${chapter}.${verse}.LSG`;
  };

  // Fonction pour formater intelligemment l'explication théologique
  const formatExplicationTheologique = (text) => {
    if (!text) return '';

    // Décoder les entités HTML pour éviter l'affichage de code CSS brut
    let formattedText = text
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#x27;/g, "'")
      .replace(/&amp;/g, '&');

    // Pas de nettoyage HTML ici - le backend renvoie du texte propre
    // Le nettoyage cassait les balises HTML que nous générons nous-mêmes

    // 1. Mettre en gras les expressions importantes entre guillemets AVANT de générer les liens
    formattedText = formattedText.replace(/"([^"]+)"/g, '<strong class="quoted-text">"$1"</strong>');

    // 2. Rendre les références bibliques cliquables - Liens directs vers YouVersion en français
    const referencePattern = /(Genèse|Exode|Lévitique|Nombres|Deutéronome|Josué|Juges|Ruth|1 Samuel|2 Samuel|1 Rois|2 Rois|1 Chroniques|2 Chroniques|Esdras|Néhémie|Esther|Job|Psaumes|Proverbes|Ecclésiaste|Cantique|Ésaïe|Jérémie|Lamentations|Ézéchiel|Daniel|Osée|Joël|Amos|Abdias|Jonas|Michée|Nahum|Habacuc|Sophonie|Aggée|Zacharie|Malachie|Matthieu|Marc|Luc|Jean|Actes|Romains|1 Corinthiens|2 Corinthiens|Galates|Éphésiens|Philippiens|Colossiens|1 Thessaloniciens|2 Thessaloniciens|1 Timothée|2 Timothée|Tite|Philémon|Hébreux|Jacques|1 Pierre|2 Pierre|1 Jean|2 Jean|3 Jean|Jude|Apocalypse)\s+(\d+):(\d+(?:-\d+)?)/g;

    formattedText = formattedText.replace(referencePattern, (match, livre, chapitre, verset) => {
      const url = getBibleVerseUrl(livre, chapitre, verset);
      return `<a href="${url}" target="_blank" class="bible-reference" title="Cliquer pour lire sur YouVersion Bible en français">${match}</a>`;
    });

    // 3. Mettre en gras les concepts théologiques importants (utiliser des classes CSS)
    const conceptsTheologiques = [
      'bénédiction divine', 'volonté de Dieu', 'fils de Dieu', 'filles d\'hommes',
      'croissance démographique', 'lignée de Seth', 'lignée de Caïn',
      'application pratique', 'sur le plan spirituel', 'contexte historique',
      'signification théologique', 'enseignement biblique', 'principe biblique',
      'perspective chrétienne', 'vérité spirituelle', 'message divin',
      'révélation divine', 'sagesse divine', 'justice divine', 'miséricorde divine',
      'alliance divine', 'promesse divine', 'amour de Dieu', 'grâce divine',
      'royaume de Dieu', 'peuple élu', 'salut', 'rédemption', 'sanctification',
      'justification', 'régénération', 'conversion', 'repentance', 'foi',
      'espérance', 'charité', 'humilité', 'obéissance', 'soumission',
      'témoignage chrétien', 'vie chrétienne', 'disciple', 'discipleship'
    ];

    conceptsTheologiques.forEach(concept => {
      const regex = new RegExp(`(${concept})`, 'gi');
      formattedText = formattedText.replace(regex, '<strong class="theological-concept">$1</strong>');
    });

    // 4. Mettre en évidence les phrases de conclusion/application
    const conclusionPatterns = [
      /(L'application pratique [^.]+\.)/gi,
      /(En conclusion[^.]+\.)/gi,
      /(Ainsi[^.]+\.)/gi,
      /(Par conséquent[^.]+\.)/gi,
      /(Il en résulte [^.]+\.)/gi,
      /(Cela nous enseigne [^.]+\.)/gi,
      /(Nous pouvons donc [^.]+\.)/gi,
      /(Cette vérité nous [^.]+\.)/gi
    ];

    conclusionPatterns.forEach(pattern => {
      formattedText = formattedText.replace(pattern, '<span style="background: #10b981; color: white !important; font-weight: 700 !important; font-style: italic; padding: 3px 8px; border-radius: 6px; display: inline-block; margin: 2px; text-shadow: 0 1px 2px rgba(0,0,0,0.3);">$1</span>');
    });

    // 5. Mettre en gras les mots-clés doctrinaux
    const motsClesDoctrinaux = [
      'fécondité', 'procréation', 'sexualité', 'mariage', 'famille',
      'responsabilité', 'intendance', 'dégénérescence', 'corruption',
      'péché', 'chute', 'rachat', 'restauration', 'nouvelle création',
      'esprit', 'âme', 'corps', 'trinité', 'incarnation', 'résurrection'
    ];

    motsClesDoctrinaux.forEach(mot => {
      const regex = new RegExp(`\\b(${mot})\\b`, 'gi');
      formattedText = formattedText.replace(regex, '<span class="doctrinal-keyword">$1</span>');
    });

    return formattedText;
  };

  return (
    <div className="vvv-page">

      {/* ── Header ── */}
      <header className="vvv-header">
        <button className="vvv-back" onClick={onGoBack}>◀ Retour</button>
        <div className="vvv-header-center">
          <span className="vvv-header-title">Verset par Verset</span>
          {bookInfo && <span className="vvv-header-sub">{bookInfo}</span>}
        </div>
        <div className="vvv-header-actions">
          <span className="vvv-batch-tag">
            {(currentBatch - 1) * 5 + 1}–{currentBatch * 5}
          </span>
          <button className="vvv-nav-prev" onClick={goToPreviousBatch} disabled={currentBatch <= 1}>◀</button>
          <button className="vvv-nav-next" onClick={loadNextBatch} disabled={isLoadingMore}>
            {isLoadingMore ? '…' : '▶'}
          </button>
          <div className="vvv-sep" />
          <button className="icon-btn" onClick={() => window.open('https://www.bible.com/', '_blank')} title="Lire la Bible">📖</button>
          <button className="icon-btn" onClick={() => { onGoBack(); setTimeout(() => window.dispatchEvent(new CustomEvent('navigate-to-notes')), 100); }} title="Notes">📝</button>
        </div>
      </header>

      {/* ── Body ── */}
      <div className="vvv-body">
        {getCurrentBatchContent() ? (
          <div className="vvv-content">
            {parseContentWithGeminiButtons(getCurrentBatchContent()).map((section) => (
              <article key={section.number} className="vvv-verse-block">

                {/* Verse header row */}
                <div className="vvv-verse-header">
                  <div className="vvv-verse-badge">{section.number}</div>
                  <span className="vvv-verse-ref">
                    {bookInfo ? `${bookInfo.split(' ').slice(0, -1).join(' ')} · v.${section.number}` : `Verset ${section.number}`}
                  </span>
                  <button
                    className="vvv-enrich-btn"
                    onClick={() => handleEnrichirVerset(section.number)}
                    disabled={!!enrichingVersets[`${currentBatch}-${section.number}`]}
                  >
                    {enrichingVersets[`${currentBatch}-${section.number}`] ? '⏳' : '✦ Approfondir'}
                  </button>
                </div>

                {/* Scripture quote */}
                {section.affichageVerset && (
                  <blockquote className="vvv-scripture">
                    <span className="vvv-scripture-text">{section.affichageVerset}</span>
                  </blockquote>
                )}

                {/* Sections */}
                <div className="vvv-sections">
                  {section.contexteHistorique && (
                    <div className="vvv-section context">
                      <div className="vvv-section-label">
                        <span className="vvv-section-icon">◈</span> Contexte historique
                      </div>
                      <div
                        className="vvv-section-body"
                        dangerouslySetInnerHTML={{ __html: formatExplicationTheologique(section.contexteHistorique) }}
                      />
                    </div>
                  )}

                  {section.partieTheologique && (
                    <div className="vvv-section theological">
                      <div className="vvv-section-label">
                        <span className="vvv-section-icon">✝</span> Partie théologique
                      </div>
                      <div
                        className="vvv-section-body"
                        dangerouslySetInnerHTML={{ __html: formatExplicationTheologique(section.partieTheologique) }}
                      />
                      {enrichingVersets[`${currentBatch}-${section.number}`] && (
                        <div className="vvv-loading-row">
                          <div className="spinner" /> Approfondissement en cours…
                        </div>
                      )}
                    </div>
                  )}
                </div>

              </article>
            ))}

            {/* Bottom nav */}
            <div className="vvv-bottom-nav">
              <button className="vvv-bottom-btn" onClick={goToPreviousBatch} disabled={currentBatch <= 1}>
                ◀ Versets précédents
              </button>
              <span className="vvv-bottom-info">
                v.{(currentBatch - 1) * 5 + 1}–{currentBatch * 5}
              </span>
              <button className="vvv-bottom-btn primary" onClick={loadNextBatch} disabled={isLoadingMore}>
                {isLoadingMore ? '⏳ Chargement…' : 'Versets suivants ▶'}
              </button>
            </div>
          </div>
        ) : (
          <div className="vvv-empty">
            <div className="empty-icon">📖</div>
            <h3>Prêt à étudier</h3>
            <p>Sélectionnez un passage depuis la page principale, puis lancez l'étude verset par verset.</p>
          </div>
        )}
      </div>

    </div>
  );
};

export default VersetParVersetPage;